import { Box, EmailConfidenceChip } from '../PulseUI';

const EmailCell = ({ row }) => {
  if (!row.email && !row.provider?.email) return null;

  const email = row.email || row?.provider?.email;
  const emailSource = row.email_source || row?.provider?.email_source;

  return (
    <Box className="flex items-center gap-1">
      {emailSource && (
        <EmailConfidenceChip source={emailSource} variant="small" />
      )}
      {email}
    </Box>
  );
};

export default EmailCell;
